import defaultConfig from '../config/bedassolution.json';

/**
 * Get the current configuration - always returns default config
 */
export const getConfig = () => {
  return defaultConfig;
};

/**
 * Check if a UI module is enabled
 * @param {string} moduleKey - The key of the module (e.g., 'bedasAlarmModule')
 * @returns {boolean}
 */
export const isModuleEnabled = (moduleKey) => {
  const config = getConfig();
  return config.uiModules?.[moduleKey]?.enabled ?? true;
};

/**
 * Check if a solution is enabled
 * @param {string} solutionKey - The key of the solution (e.g., 'cognien')
 * @returns {boolean}
 */
export const isSolutionEnabled = (solutionKey) => {
  const config = getConfig();
  return config.solutions?.[solutionKey]?.enabled ?? true;
};

/**
 * Reset configuration to default
 */
export const resetConfig = () => {
  localStorage.removeItem('bedasConfig');
};
